import { reduxRequest } from "common/utils/reduxRequest";
import { makeFilterString } from "../utils/Helper";
import {
  financialLoading,
  getFinancesSuccess,
  getFinancialStatusSuccess,
  getStoreTransactionsSuccess,
} from "./Action";

export const getFinances = ({ ...variables } = {}) => {
  const requestData = {
    isLoading: financialLoading,
    loadingType: "finances",
    successFunction: getFinancesSuccess,
    url: `/admin/finances${makeFilterString(variables?.params)}`,
    method: "get",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const getFinancialStatus = ({ ...variables } = {}) => {
  // variables can contain store_id if needed
  const storeIdParam = variables?.storeId
    ? `?store_id=${variables.storeId}`
    : "";
  const requestData = {
    isLoading: financialLoading, // Or maybe separate loading type if we want granular loading
    loadingType: "financialStatus",
    successFunction: getFinancialStatusSuccess,
    url: `/admin/store_transactions/financial_status${storeIdParam}`,
    method: "get",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const getStoreTransactions = ({ ...variables } = {}) => {
  const requestData = {
    isLoading: financialLoading,
    loadingType: "storeTransactions",
    successFunction: getStoreTransactionsSuccess,
    url: `/admin/store_transactions${makeFilterString(variables?.params)}`,
    method: "get",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};
